"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TOP_BAR_V2_EXPERIMENT_LINK_DATA = exports.TOP_BAR_V2_EXPERIMENT_LINK_DATA = [{
    "url": "javascript:;",
    "text": "Pricing",
    "options": {
        "class": "m-link-list--link-break-1",
        "container_class": "experiment-top-bar-v2",
        "sub_menu_items": [{
            "url": "/info/pricing",
            "text": "HelloSign"
        }, {
            "url": "/api/pricing",
            "text": "API"
        }],
        "sub_menu_class": "experiment-top-bar-v2",
        "sub_menu_lock_to_parent": true,
        "show_menu_drop_down_arrow": true
    }
}, {
    "url": "/api",
    "text": "Developers",
    "options": {
        "class": "m-link-list--link-break-1",
        "container_class": "experiment-top-bar-v2"
    }
}, {
    "url": "javascript:;",
    "text": "Customers",
    "options": {
        "class": "m-link-list--link-break-1",
        "container_class": "experiment-top-bar-v2",
        "sub_menu_items": [{
            "url": "http://info.hellosign.com/instacart-case-study.html",
            "text": "Instacart",
            "options": {
                "target": "_blank"
            }
        }, {
            "url": "http://info.hellosign.com/simplyinsured-case-study.html",
            "text": "Simply Insured",
            "options": {
                "target": "_blank"
            }
        }, {
            "url": "http://info.hellosign.com/openlegal-case-study.html",
            "text": "OpenLegal",
            "options": {
                "target": "_blank"
            }
        }, {
            "url": "http://info.hellosign.com/trxade-case-study.html",
            "text": "Trxade",
            "options": {
                "target": "_blank"
            }
        }],
        "sub_menu_class": "experiment-top-bar-v2",
        "sub_menu_lock_to_parent": true,
        "show_menu_drop_down_arrow": true
    }
}, {
    "url": "javascript:;",
    "text": "Products",
    "options": {
        "class": "m-link-list--link-break-1",
        "container_class": "experiment-top-bar-v2",
        "sub_menu_items": [{
            "url": "/info/tour",
            "text": "HelloSign"
        }, {
            "url": "/api",
            "text": "API"
        }, {
            "url": "/info/tour#googleIntegrations",
            "text": "Google Apps"
        }],
        "sub_menu_class": "experiment-top-bar-v2",
        "sub_menu_lock_to_parent": true,
        "show_menu_drop_down_arrow": true
    }
}];

var TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD = exports.TOP_BAR_V2_EXPERIMENT_SCREEN_THRESHOLD = 1050; // pixels

var TOP_BAR_V2_EXPERIMENT_COOKIE_NAME = exports.TOP_BAR_V2_EXPERIMENT_COOKIE_NAME = 'hs_experiment_top_bar_v2'; // Used for analytics
var TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE = exports.TOP_BAR_V2_EXPERIMENT_COOKIE_VALUE = 'top_bar_v2_enabled'; // Used for analytics
var TOP_BAR_V2_EXPERIMENT_NAME = exports.TOP_BAR_V2_EXPERIMENT_NAME = 'top_bar_v2_enabled';


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/top-bar-menu/experiments/top-bar-v2.js
 ** module id = 769
 ** module chunks = 0
 **/